<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ editing ? 'Sửa' : 'Xem chi tiết'}} bộ phận sử dụng</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getSyncSourceType(department.syncSourceType) }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Đơn vị trực thuộc:"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ department.unitName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Bộ phận sử dụng cha:"
                                              label-for="input-parentname"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect id="input-parentname" class="col-md-6 no-padding"
                                                v-if="editing"
                                                ref="departmentTree"
                                                v-model="department.parentId"
                                                :max-height="390"
                                                placeholder="Nhập bộ phận sử dụng"
                                                :options="departmentTree" />
                                    <label class="col-form-label" v-if="!editing">{{ department.unitName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Mã bộ phận sử dụng: "
                                              label-for="input-code"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              :label-class="editing ? 'required': ''"
                                              label-align="left">
                                    <b-form-input type="text" id="input-code"
                                                  class="col-md-6"
                                                  v-if="editing"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.department.code.$model"
                                                  :state="($v.department.code.$dirty? !$v.department.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback" v-if="$v.department.code.$error">
                                        Vui lòng nhập mã
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingCodeFeedback" v-if="!$v.department.code.$error && ($v.codeUnique.$error)">
                                        Mã bộ phận sử dụng đã tồn tại
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ department.code }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Tên bộ phận sử dụng: "
                                              label-for="input-name"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              :label-class="editing ? 'required': ''"
                                              label-align="left">
                                    <b-form-input type="text" id="input-name"
                                                  class="col-md-6"
                                                  v-if="editing"
                                                  aria-describedby="nameFeedback"
                                                  v-model="$v.department.name.$model"
                                                  :state="$v.department.name.$dirty? !$v.department.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback">
                                        Vui lòng nhập tên
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ department.name }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Địa chỉ:"
                                              label-for="address"
                                              label-cols-md="3"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-textarea id="textarea"
                                                     v-if="editing"
                                                     v-model="department.address"
                                                     placeholder="Nhập địa chỉ..."
                                                     rows="5"
                                                     class="col-md-6"
                                                     max-rows="5"></b-form-textarea>
                                    <label class="col-form-label" v-if="!editing">{{ department.address }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Số điện thoại:"
                                              label-for="phone"
                                              label-cols-md="3"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input type="text" id="phone"
                                                  class="col-md-6"
                                                  v-if="editing"
                                                  v-model="department.phoneNumber"
                                                  placeholder="">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ department.phoneNumber }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Fax:"
                                              label-for="isActive"
                                              label-cols-md="3"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input type="text" id="fax"
                                                  v-if="editing"
                                                  class="col-md-6"
                                                  v-model="department.fax">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ department.fax }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
        <b-col offset-md="2">
            <b-form-group label="Trạng thái hoạt động:"
                          label-for="fax"
                          :label-cols="4"
                          label-cols-md="3"
                          label-align="left"
                          :horizontal="true">
                <b-form-checkbox v-model="department.isActive"></b-form-checkbox>
            </b-form-group>
        </b-col>
    </b-row>-->
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="" label-cols-md="3">
                                    <b-button type="submit" variant="primary" v-if="authorize(['ManageDepartment']) && editing"> Lưu</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '../' }"> Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required } from 'vuelidate/lib/validators'
import { setTimeout } from 'core-js'

    export default {
        name: 'DepartmentDetail',
        mixins: [validationMixin, mixins],
        data() {
            return {
                codeUnique: 'ok',
                department: {},
                departmentTree: [],
                flag: false,
                editing: this.$route.meta.editing
            }
        },
        computed: {
            departmentId() {
                return this.$route.params.departmentId;
            }
        },
        validations: {
            department: {
                code: { required },
                name: { required }
            },
            codeUnique: { required }
        },
        watch: {
            'department.parentId'(val) {
                if (val && this.flag) {
                    var codeParent = this.$store.getters.getDepartmentTreeCode(this.departmentTree, val);
                    this.department.code = codeParent;
                }
            }
        },
        created() {
            var vm = this;
            vm.loadDepartmentDetail();
            vm.loadDepartments();
        },
        methods: {
            loadDepartments() {
                var vm = this;
                return this.$services.get(`lookup/departments`).done(data => {
                    vm.departmentTree = vm.$store.getters.buildDepartmentTree(data);
                });
            },
            loadDepartmentDetail() {
                var vm = this;
                return this.$services.get(`master-data/departments/${this.departmentId}`).done(department => {
                    vm.department = department;
                });
            },
            back() {
                this.$router.push({ path: '../' });
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (vm.department.code != null && vm.department.code != '') {
                    vm.$services.get(`master-data/existing-departments-code`, { unitId: vm.department.unitId, id: vm.department.id || '', code: vm.department.code || '' }).done(returnData => {
                        if (!returnData) {
                            vm.codeUnique = "required";
                            if (!vm.$v.$invalid) {
                                vm.$services.put(`master-data/departments/${vm.departmentId}`, vm.department).done(() => {
                                    vm.$toastr.s('Cập nhật bộ phận sử dụng thành công');
                                    vm.back();
                                });
                            }
                        }
                        else {
                            vm.codeUnique = "";
                        }
                    });
                }
            },
        }
    }
</script>
<style scoped>
</style>
